import axios from "./axios";
import { AxiosReturn } from "./types";
import * as Requests from "./requests";
import { IAccountManager, IStore } from "../types";

export const getStore = (token): AxiosReturn<{ store: IStore; account_manager: IAccountManager | null }> => {
  return axios.get(Requests.store, {
    headers: {
      token,
    },
  });
};
